import GeofencesCreateApp from '../Functionality/GeofencesCreateApp';
import HeadTittle from '../../../../../components/HeadTittle';
import DivContainerBody from '../../../../../components/DivContainerBody';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import DetailsStep from './DetailsStep';
import DefineAreaStep from './DefineAreaStep';
import GeofenceSummary from './GeofenceSummary';
import { CREATE_STEP } from '../Model/Model';
import ActiveScheduleStep from './ActiveSheduleStep';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const GeofencesCreate = () => {
    const {
        t,
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        handleStepSetUp,
        handleOnBack,
        disabled,
        item,
        emptyFields,
        setItem,
        dayArray,
        setDayArray,
        handleAdd,
        handleChange,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        isCloseTimeInvalid,
        isEqualTimes,
    } = GeofencesCreateApp();

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'create'} />
            <DivContainerBody>
                <>
                    <StepperTabs
                        id={null}
                        disabled={false}
                        steps={steps}
                        activeStep={activeStep}
                        isStepOptional={() => {}}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                    >
                        <StepTab index={CREATE_STEP.DETAILS} activeStep={activeStep} normalHeight={true}>
                            <DetailsStep
                                disabled={disabled}
                                handleChange={handleChange}
                                emptyFields={emptyFields}
                                item={item}
                                t={t}
                            />
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_gc_next_dish'
                                    text='next'
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={CREATE_STEP.ACTIVE_SCHEDULE} activeStep={activeStep} normalHeight={true}>
                            <ActiveScheduleStep
                                item={item}
                                t={t}
                                handleChange={handleChange}
                                emptyFields={emptyFields}
                                dayArray={dayArray}
                                setDayArray={setDayArray}
                                setItem={setItem}
                                disabled={disabled}
                                isCloseTimeInvalid={isCloseTimeInvalid}
                                isEqualTimes={isEqualTimes}
                                formatValue={true}
                            />
                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_gc_back_file'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_gc_next_file'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={CREATE_STEP.DEFINE_AREA} activeStep={activeStep} normalHeight={true}>
                            {activeStep === CREATE_STEP.DEFINE_AREA &&
                                <>
                                    <div className={"col-12"}>
                                        <DefineAreaStep
                                            t={t}
                                            geofences={geofences}
                                            setGeofences={setGeofences}
                                            latitude={latitude}
                                            setLatitude={setLatitude}
                                            longitude={longitude}
                                            setLongitude={setLongitude}
                                            emptyFields={emptyFields}
                                            item={item}
                                            setItem={setItem}
                                            center={[latitude, longitude]}
                                        />
                                    </div>

                                    <div className='d-flex justify-content-between px-0 mt-3'>
                                        <ButtonPrevStep
                                            id='btn_gc_back_file'
                                            text='back'
                                            click={() => setActiveStep((prevStep) => prevStep - 1)}
                                        />
                                        <ButtonNextStep
                                            id='btn_gc_next_file'
                                            text='next'
                                            disabled={activeStep === steps.length - 1}
                                            click={() => {
                                                if (handleStepSetUp()) {
                                                    setActiveStep((prevStep) => prevStep + 1);
                                                }
                                            }}
                                        />
                                    </div>
                                </>
                            }
                        </StepTab>
                        <StepTab index={CREATE_STEP.SUMMARY} activeStep={activeStep} normalHeight={true}>
                            {activeStep === CREATE_STEP.SUMMARY &&
                                <>
                                    <GeofenceSummary
                                        item={item}
                                        dayArray={dayArray}
                                        t={t}
                                        geofences={geofences}
                                        center={[latitude, longitude]}
                                    />
                                    <div className='d-flex justify-content-between px-0 mb-2'>
                                        <ButtonPrevStep
                                            id='btn_gc_back_summary'
                                            text='back'
                                            click={() => setActiveStep((prevStep) => prevStep - 1)}
                                        />
                                        <ButtonNextStep
                                            id='btn_gc_create'
                                            text='create'
                                            click={() => {
                                                handleAdd();
                                            }}
                                        />
                                    </div>
                                </>
                            }
                        </StepTab>
                    </StepperTabs>
                </>
            </DivContainerBody>
        </>
    );
};

export default GeofencesCreate;
